<app-candidate-job-matches-workflow
    [jobId]="jobId"
    [globalQueryFilterObject]="globalQueryFilterObject"
    [reqStateData]="reqStateData">
</app-candidate-job-matches-workflow>
